const initialZipListState = {
  list: [],
  loading: false,
};

const SET_ZIP_LIST = "SET_ZIP_LIST";
export const setZipList = (zipList) => ({
  type: SET_ZIP_LIST,
  payload: { zipList },
});

const SET_ZIP_LIST_LOADING = "SET_ZIP_LIST_LOADING";
export const setZipListLoading = (zipListLoading) => ({
  type: SET_ZIP_LIST_LOADING,
  payload: { zipListLoading },
});

export const zipListReducer = (
  state = initialZipListState,
  { type, payload }
) => {
  switch (type) {
    case SET_ZIP_LIST:
      return {
        ...state,
        list: [...payload.zipList.list],
      };
    case SET_ZIP_LIST_LOADING:
      return {
        ...state,
        loading: payload.zipListLoading,
      };
    default:
      return state;
  }
};
